import { LeftOutlined, MenuOutlined } from '@ant-design/icons';
import { Carousel, Dropdown, Image, Modal, Spin, Typography, Watermark } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../../constants/link';
import { thousandSeparator } from '../../utils/numberManager';
import { useCar, useDeleteCar } from '../../zustand/store';
import ExpenseList from './expenseList';
import { DataWrapper, GoBackBtn, MenuBtn, Wrapper } from './styles';
import dayjs from 'dayjs';

const DropdownSection = () => {
    const [open, setOpen] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const car = useCar();
    const data = car?.data;

    const del = useDeleteCar();

    const confirmDelete = () => {
        del.execute({
            params: { id },
            onSuccess: () => {
                navigate(`/`);
            }
        });
    }

    return <>
        <Dropdown menu={{
            items: [
                !data?.sold &&
                {
                    label: "Mark as Sold Out", key: "Sold",
                    onClick: () => {
                        navigate(`/car/${id}/expense/new?c=Sold`)
                    }
                },
                {
                    label: "Edit", key: "edit", onClick: () => {
                        navigate(`/car/${id}/edit`);
                    }
                },
                { label: "Delete", key: "delete", onClick: () => { setOpen(true) } },
            ],
        }}>
            <MenuBtn>
                <MenuOutlined />
            </MenuBtn>
        </Dropdown>
        <Modal
            onOk={confirmDelete}
            title="Delete" centered open={open} onCancel={() => setOpen(false)} okText="Delete" okButtonProps={{ danger: true }}>
            Do you really want to delete this?
        </Modal>
    </>
}

function SingleCarPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const car = useCar();
    const data = car?.data;

    useEffect(() => {
        car.execute({ params: { id }, force: true });
    }, [])
    return (
        <Watermark content={data?.sold && "SOLD OUT"}>
            <Wrapper>
                <GoBackBtn onClick={() => {
                    navigate("/");
                }}>
                    <LeftOutlined />
                </GoBackBtn>
                <DropdownSection />
                <Spin spinning={car?.loading}>

                    <Carousel arrows infinite>
                        {data?.images?.map(({ photo }, i) => (
                            <div >
                                {/* <Image.PreviewGroup>
                                {data?.images?.map(({ photo }, j) => ( */}
                                <Image
                                    width={"100%"}
                                    height={"300px"}

                                    style={{
                                        objectFit: "cover", objectPosition: "center",
                                        // ...(i !== j ? ({ display: "none" }) : {})
                                    }}
                                    src={`${BASE_URL}/file/${photo?.[photo.length - 1]?.file_id}`}
                                />
                                {/* ))}

                            </Image.PreviewGroup> */}

                            </div>
                        ))
                        }
                    </Carousel>

                    {/* <ImgWrapper>
                    <img src={data?.img || defaultCar} alt='img' />
                    <UploadImgWrapper>
                        <CloudUploadOutlined />
                        <input type="file" />
                    </UploadImgWrapper>
                </ImgWrapper> */}
                    {!data?.images?.length && <div style={{ height: "50px", width: "100%", }} />}
                    <DataWrapper>
                        <Typography.Title level={5} style={{ margin: 0 }}>
                            {data?.make || "NO_MAKE"} / {data?.model || "NO_MODEL"}
                        </Typography.Title>
                        <div>
                            <Typography.Text>
                                {data?.year || "NO_YEAR"} | {data?.price ? `$${thousandSeparator(data?.price)}` : "NO_PRICE"}
                            </Typography.Text>
                        </div>
                        <div>
                            <Typography.Text>
                                {data?.note}
                            </Typography.Text>
                        </div>
                        <div>
                            <Typography.Text type="secondary">
                                <small>
                                    {dayjs(data?.addedAt).format("DD/MMM/YY")}
                                </small>
                            </Typography.Text>
                        </div>
                        <br />
                        <div>
                            <Typography.Text type='danger'>
                                Expense: ${thousandSeparator(data?.expense || 0)}
                            </Typography.Text>
                        </div>

                        <div>
                            <Typography.Text type="success">
                                Income: ${thousandSeparator(data?.income || 0)}
                            </Typography.Text>
                        </div>

                        <div>
                            <Typography.Text>
                                Profit: {data?.profit < 0 && "-"}${thousandSeparator(Math.abs(data?.profit) || 0)}
                            </Typography.Text>
                        </div>
                    </DataWrapper>

                </Spin>
                <ExpenseList />
                {/* <FloatButton icon={<PlusOutlined />} type='primary' /> */}
            </Wrapper>
        </Watermark>
    )
}

export default SingleCarPage